import { useState } from "react";
import { Box, Flex } from "rebass";
import useResponsive from "../../hooks/useResponsive";
import { Price } from "../common/Price";

const SummaryTableRow = ({
  name,
  qty = 0,
  price = 0,
  detail = null,
  secondary = false,
  total = false,
  disableFormatting = false,
  sx = {},
  labelPadding = 0,
  defaultExpanded = false,
  totalActions = null,
}) => {
  const [detailExpanded, setDetailExpanded] = useState(defaultExpanded);

  const { breakpoint } = useResponsive();

  const TableSpacer = () => (
    <Box sx={{ width: breakpoint([1, 1]) }} backgroundColor="#878787"></Box>
  );
  return (
    <Flex
      flexDirection={"column"}
      width="100%"
      sx={{
        borderBottom: secondary || total ? "none" : "1px solid #878787",
        fontSize: ".9em",
      }}
    >
      <Flex
        sx={{
          width: "100%",
          ...(secondary && {
            opacity: 0.7,
          }),
          ...(!!detail && {
            ":hover": {
              cursor: "pointer",
              opacity: 0.8,
            },
          }),
          ...sx,
        }}
        onClick={() => setDetailExpanded(!detailExpanded)}
      >
        <Flex
          width={breakpoint([1 / 2, 3 / 4])}
          sx={{ ...(total && { backgroundColor: "#646464" }) }}
        >
          <Flex
            width={"100%"}
            fontWeight={!secondary ? 600 : 400}
            justifyContent={
              secondary ? "right" : total ? "space-between" : "flex-start"
            }
            pr={2}
            pl={labelPadding}
          >
            <Box
              sx={{
                padding: secondary ? "3px 0 0 10px" : "7px 0 0 10px",
                ...((!detail || secondary) && {
                  display: "none",
                }),
              }}
            >
              {!detailExpanded ? "+" : "-"}
            </Box>
            {(total && totalActions) || null}
            <Box p={secondary ? 1 : 2}>{name}</Box>
          </Flex>
        </Flex>
        <TableSpacer />
        <Flex
          width={breakpoint([2 / 10, 1 / 6])}
          justifyContent="center"
          fontWeight={!secondary ? 600 : 400}
        >
          <Box p={secondary ? 1 : 2}>{qty}</Box>
        </Flex>
        <TableSpacer />
        <Flex
          width={breakpoint([3 / 10, 1 / 6])}
          justifyContent="right"
          fontWeight={!secondary ? 600 : 400}
          paddingRight={"15px"}
        >
          <Box p={secondary ? 1 : 2}>
            {disableFormatting ? price : <Price price={price} />}
          </Box>
        </Flex>
      </Flex>
      {!!detailExpanded && detail}
    </Flex>
  );
};

export default SummaryTableRow;
